import { IconButton, Stack, Tab, Typography } from '@mui/material';
import { useState } from 'react';
import { CPTabs } from 'src/components/base/CPTabs';
import { Iconify } from 'src/components/iconify';
import { NavTabItem } from 'src/components/nav-section';
import { HeaderIcon } from 'src/layouts/DashboardLayout/shared/styles';
import { useLocales } from 'src/locales';
import { RightMenuHeader } from '../shared/styles';
import { CloudContent } from './CloudContent';

const useTabs = () => {
  const { translate } = useLocales();

  const TABS: Partial<NavTabItem>[] = [
    {
      value: 'medias',
      label: translate('shared.labels.medias'),
      icon: <Iconify icon="tabler:layout-board-split" />,
      component: <CloudContent isMedia />,
    },
    {
      value: 'documents',
      label: translate('shared.labels.documents'),
      icon: <Iconify icon="tabler:file-description" />,
    },
  ];
  return TABS;
};

export const Cloud = ({ onClose }: { onClose(): void }) => {
  const [currentTab, setCurrentTab] = useState('medias');
  const { translate } = useLocales();
  const TABS = useTabs();
  return (
    <Stack
      sx={{
        flexGrow: 1,
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <RightMenuHeader>
        <Stack direction="row" alignItems="center" gap={2}>
          <HeaderIcon>
            <Iconify icon="tabler:photo-video" sx={{ color: 'primary.main' }} />
          </HeaderIcon>
          <Typography variant="h6">
            {translate('shared.labels.files')}
          </Typography>
        </Stack>
        <IconButton onClick={onClose}>
          <Iconify icon="tabler:x" />
        </IconButton>
      </RightMenuHeader>
      <Stack sx={{ flexGrow: 1, overflow: 'hidden', maxHeight: '100%' }}>
        <CPTabs
          value={currentTab}
          onChange={(event, newValue) => setCurrentTab(newValue)}
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              label={tab.label}
              sx={{ flexGrow: 1 }}
              icon={tab.icon}
            />
          ))}
        </CPTabs>
        <CloudContent isMedia={currentTab === 'medias'} />
      </Stack>
    </Stack>
  );
};
